import {useEffect, useRef} from 'react';
import {useLocation} from 'react-router';

import {useCurrentProject} from 'common/contexts/react/current-project-context';
import {useThemes} from 'common/contexts/react/themes-context';
import {useTours} from 'common/contexts/react/tours-context';
import {IMMERSIVE_ONBOARDING_URL_PARAM} from 'common/onboarding/immersive-onboarding/constants';
import {initializeImmersiveOnboarding} from 'common/onboarding/immersive-onboarding-initializer';
import {isChartCustomizationEnabled} from 'common/query-builder/chart-customization/utils';
import {TourName} from 'common/util/tour-constants';

export function useNavigationEffects(): void {
  const tours = useTours();
  const location = useLocation();
  const currentProject = useCurrentProject();
  const themesResource = useThemes();
  const hasChartCustomization = isChartCustomizationEnabled(currentProject.get().value);
  useEffect(() => {
    if (hasChartCustomization) {
      themesResource.getAll();
    }
  }, [hasChartCustomization]);

  useEffect(() => {
    themesResource.setGlobalHoveredItem(null);
    themesResource.resetColorMappings();

    // load app level tours here
    tours.openTour(TourName.MOBILE_SR_TOUR);
  }, [location.pathname]);
}

export function useImmersiveOnboarding() {
  const location = useLocation();
  const initialized = useRef(false);
  const currentProject = useCurrentProject();

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has(IMMERSIVE_ONBOARDING_URL_PARAM) && !initialized.current) {
      initialized.current = true;
      setTimeout(() => {
        initializeImmersiveOnboarding({
          currentProjectResource: currentProject,
        });
      }, 500);
    }
  }, [location.search]);
}
